export default {
    state: {
        width: null
    },
    getters: {
        getWidth(state) {
            return state.width
        },
    },
    mutations: {
        setWidth(state, data) {
            state.width = data
        },
    },
    actions: {
        updateWidth (ctx, data) {
            ctx.commit('setWidth', data)
            return true
        }
    }
}